import type React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";

const LogoutPage: React.FC = () => {
	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	useEffect(() => {
		const run = async () => {
			const { error } = await supabase.auth.signOut();
			if (error) {
				setErrorMessage(error.message);
				return;
			}
			window.location.href = "/auth";
		};

		run();
	}, []);

	return (
		<div className="min-h-screen flex items-center justify-center surface-alt px-6">
			<div className="card p-6 w-full max-w-md">
				<h1 className="text-xl font-semibold">Logging out...</h1>
				<p className="mt-2 text-sm text-muted">You will be redirected to login.</p>

				{errorMessage && (
					<div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
						Logout failed: {errorMessage}
					</div>
				)}

				<div className="mt-6 flex items-center gap-3">
					<Link className="btn btn-secondary btn-md" to="/">
						Go Home
					</Link>
					<Link className="btn btn-primary btn-md" to="/auth">
						Login
					</Link>
				</div>
			</div>
		</div>
	);
};

export default LogoutPage;
